import AppDispatcher from '../dispatcher/AppDispatcher';
import AccountPoolsConstant from '../constants/AccountPoolsConstant';
import moment from 'moment';

export default class AccountPoolsActionCreator {
  static getAccountPools() {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_ACCOUNT_POOLS,
    });
  }
  static getAccountPoolsSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_ACCOUNT_POOLS_SUCCESS,
      data: response,
    });
  }
  static getAccountPoolsFailure(error) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_ACCOUNT_POOLS_FAILURE,
      data: error,
    });
  }
  static setAccountPoolId(id) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.SET_ACCOUNT_POOL_ID,
      data: id,
    });
  }
  static buildAccountPoolPayload(
    accountPoolName,
    popularNotionalCurrency,
    notionalCurrency,
    selectedAccounts
  ) {
    const selectedAccountIds = selectedAccounts.map((accountId) => ({
      id: accountId,
    }));
    return {
      name: accountPoolName,
      currency:
        popularNotionalCurrency !== 'other'
          ? popularNotionalCurrency
          : notionalCurrency,
      accounts: selectedAccountIds,
    };
  }
  static createAccountPool(state) {
    const {
      accountPoolName,
      popularNotionalCurrency,
      notionalCurrency,
      selectedAccounts,
    } = state;
    const request = this.buildAccountPoolPayload(
      accountPoolName,
      popularNotionalCurrency,
      notionalCurrency,
      selectedAccounts
    );
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.CREATE_ACCOUNT_POOL,
      data: request,
    });
  }
  static createAccountPoolSuccess(request) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.CREATE_ACCOUNT_POOL_SUCCESS,
      data: request,
    });
  }
  static createAccountPoolFailure(request) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.CREATE_ACCOUNT_POOL_FAILURE,
      data: request,
    });
  }
  static getAccountList() {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_ACCOUNT_LIST,
    });
  }
  static getAccountListSuccess(request) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_ACCOUNT_LIST_SUCCESS,
      data: request,
    });
  }
  static getAccountListFailure(request) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_ACCOUNT_LIST_FAILURE,
      data: request,
    });
  }
  static resetPool() {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.RESET_POOL,
    });
  }
  static updateAccountPool(state) {
    const {
      accountPoolName,
      popularNotionalCurrency,
      notionalCurrency,
      selectedAccounts,
    } = state;
    const request = this.buildAccountPoolPayload(
      accountPoolName,
      popularNotionalCurrency,
      notionalCurrency,
      selectedAccounts
    );
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.UPDATE_POOL,
      data: request,
    });
  }
  static updateAccountPoolSuccess(request) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.UPDATE_POOL_SUCCESS,
      data: request,
    });
  }
  static updateAccountPoolFailure(request) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.UPDATE_POOL_FAILURE,
      data: request,
    });
  }
  static deleteAccountPool() {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.DELETE_ACCOUNT_POOL,
    });
  }
  static getSpecificPoolDetails() {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_SPECIFIC_POOL_DETAIL,
    });
  }
  static getSpecificPoolDetailsSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_SPECIFIC_POOL_DETAIL_SUCCESS,
      data: response,
    });
  }
  static getSpecificPoolFailure() {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.GET_SPECIFIC_POOL_DETAIL_FAILURE,
    });
  }
  static setEditModeFlag() {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.SET_EDIT_MODE,
    });
  }
  static transactionExportPayload(startDate, endDate, accountIds) {
    return {
      start_date: moment(startDate).format('YYYY-MM-DD'),
      end_date: moment(endDate).format('YYYY-MM-DD'),
      file_type: 'MultiAccountsExtendedNarrativeCsv',
      account_list: accountIds,
    };
  }
  static exportTransactions(startData, endDate, accountIds) {
    const request = this.transactionExportPayload(
      startData,
      endDate,
      accountIds
    );
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.EXPORT_TRANSACTIONS,
      data: request,
    });
  }
  static resetAccountDetailsFlag() {
    AppDispatcher.handleServerAction({
      actionType: AccountPoolsConstant.RESET_ACCOUNT_DETAIL_FLAG,
    });
  }
}
